import ReportsWorkspace from "@/components/feature/reports/ReportsWorkspace";
import { useOwnerReports } from "./useOwnerReports";

export default function RapportsPage() {
  const { reportTypes, options, getStatutConfig, buildReport } = useOwnerReports();

  return (
    <ReportsWorkspace
      heading="Rapports"
      intro="Générez, prévisualisez puis téléchargez vos rapports d'activité. Chaque rapport s'appuie sur les données réelles de votre espace et respecte exactement les filtres sélectionnés."
      reportTypes={reportTypes}
      options={options}
      getStatutConfig={getStatutConfig}
      buildReport={buildReport}
      filenamePrefix="rapports-proprietaire"
    />
  );
}